// These are the most simple getters,
// they will navigate the path, return the data found
// or default to null or undefined

export const selectSidebarDetour = ($) => $?.sidebar?.general?.detour;
export const selectSidebarOpen = ($) => $?.sidebar?.general?.open;
export const selectSidebarDim = ($) => $?.sidebar?.general?.dim;
export const selectSidebarPanel = ($) => $?.sidebar?.general?.panel;

export const selectSidebarAppointmentId = ($) => $?.sidebar?.appointment?.appointmentId;
export const selectSidebarAppointmentClientId = ($) => $?.sidebar?.appointment?.clientId;

export const selectSidebarAppointmentSms = ($) => $?.sidebar?.appointment?.smsLog;
export const selectSidebarAppointmentSmsCount = ($) => $?.sidebar?.appointment?.smsLog?.messageCount;
export const selectSidebarAppointmentSmsDirty = ($) => $?.sidebar?.appointment?.smsLog?.isSmsInputDirty;
export const selectSidebarAppointmentSmsEdit = ($) => $?.sidebar?.appointment?.smsLog?.isEditMode;
export const selectSidebarAppointmentSmsInput = ($) => $?.sidebar?.appointment?.smsLog?.smsInput;
export const selectSidebarAppointmentSmsMessageSource = ($) => $?.sidebar?.appointment?.smsLog?.smsMessageSource;
export const selectSidebarAppointmentSmsUpdatedAt = ($) => $?.sidebar?.appointment?.smsLog?.updatedAt;

export const selectSidebarProcedureModalMounted = ($) => $?.sidebar?.procedureModal?.mounted;

export const selectRequestedDepositValue = ($) => $?.sidebar?.deposit?.requestValue;
export const selectTakeDepositInput = ($) => $?.sidebar?.deposit?.takeInput;
export const selectTakeDepositSource = ($) => $?.sidebar?.deposit?.source;
